import React, { useMemo } from "react";
import { Modal, Box, Typography } from "@mui/material";
import LoadingSpinner from "../LoadingSpinner";

export default function ProcessingModal({
    open,
    onClose,
    spinner,
    title = "Processing files",
    subtitle = "Files are being uploaded. Please do not close or refresh this window while the upload is in progress.",
    actionLabel = "Return",
    filesProgress = [],
}) {
    const sortedFiles = useMemo(() => {
        return [...filesProgress].sort((a, b) => {
            const isMetaA = a.fileName?.toLowerCase().includes("meta");
            const isMetaB = b.fileName?.toLowerCase().includes("meta");

            if (isMetaA && !isMetaB) return -1;
            if (!isMetaA && isMetaB) return 1;

            return 0;
        });
    }, [filesProgress]);

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    display: "grid",
                    placeItems: "center",
                    p: 2,
                }}
            >
                <Box
                    sx={{
                        position: "relative",
                        width: "50%",
                        height: "50%",
                        maxWidth: 1000,
                        bgcolor: "#000",
                        borderRadius: 4,
                        border: "1px solid rgba(255,255,255,0.7)",
                        color: "#fff",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        px: 4,
                        py: 4,
                    }}
                >
                    <Box sx={{ mb: 4 }}>
                        <LoadingSpinner size={160} barHeight={32} barWidth={12} color="#fff" />
                    </Box>

                    <Typography
                        sx={{
                            fontSize: 34,
                            mb: 1,
                        }}
                    >
                        {title}
                    </Typography>

                    <Typography
                        sx={{
                            maxWidth: 500,
                            opacity: 0.8,
                            mb: 4,
                            fontSize: 16,
                            lineHeight: 1.6,
                        }}
                    >
                        {subtitle}
                    </Typography>

                    {sortedFiles.length > 0 && (
                        <Box
                            sx={{
                                width: "100%",
                                maxWidth: 620,
                                display: "flex",
                                flexDirection: "column",
                                gap: 1.5,
                                mt: 1,
                            }}
                        >
                            {sortedFiles.map((file) => (
                                <Box
                                    key={file.fileName}
                                    sx={{
                                        width: "100%",
                                        textAlign: "left",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            gap: 2,
                                            mb: 0.5,
                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                maxWidth: "80%",
                                            }}
                                        >
                                            {file.fileName}
                                        </Typography>

                                        <Typography variant="body2">
                                            {Number(file.percentage || 0).toFixed(2)}%
                                        </Typography>
                                    </Box>

                                    <Box
                                        sx={{
                                            width: "100%",
                                            height: 8,
                                            borderRadius: 9999,
                                            bgcolor: "rgba(255,255,255,0.18)",
                                            overflow: "hidden",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: `${Math.min(Number(file.percentage || 0), 100)}%`,
                                                height: "100%",
                                                bgcolor: "#20BC71",
                                                transition: "width 0.2s ease",
                                            }}
                                        />
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    )}
                </Box>
            </Box>
        </Modal>
    );
}